export const inspectUndefined = () => "undefined"
